import { headerNav } from '../data/HeaderData';
import { useToggle } from '../hooks/useToggle';
import MobileMenuDropdown from './MobileMenuDropdown';

const Header: React.FC = () => {
  const { isOpen: isMenuActive, toggle: toggleMenu } = useToggle();
  const isMobile = window.innerWidth < 768;

  return (
    <>
      <header className="sb-header">
        <div className="sb-header-inner">
          <h1 className='m-0 d-flex'>
            <a href="#home" className="sb-logo">
              <span className="sb-logo-swept">Swept</span>
              <span className="sb-logo-books">Books</span>
            </a>
          </h1>

          {/* Desktop Nav */}
          <ul className="sb-nav sb-nav-desktop">
            {headerNav.map((link, index) => (
              <li key={index}>
                <a href={link.url}>{link.text}</a>
              </li>
            ))}
          </ul>

          {/* Mobile Hamburger */}
          <button
            className={`sb-hamburger ${isMenuActive ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
            aria-expanded={isMenuActive}
          >
            <span className="sb-bar" />
            <span className="sb-bar" />
            <span className="sb-bar" />
          </button>
        </div>
        {isMobile && isMenuActive && <MobileMenuDropdown onClose={toggleMenu} />}
      </header>

    </>
  );
};

export default Header;